module.exports = __webpack_public_path__ + "static/media/logo_white.5103a10f.svg";